import MuiTableBody from "@mui/material/TableBody";
import { IdentifiableWithCalculatedParams, TableBodyProps } from "../../../types";
import TableRow from "./TableRow";

const TableBody = <
  T extends IdentifiableWithCalculatedParams,
  CollapsingRowName extends string | undefined = undefined,
>({
  data,
  collapsingRowName,
  onRowClick,
  getRowBackgroundColor,
  getRowOpacity,
  selectedProps,
}: TableBodyProps<T, CollapsingRowName>) => {
  return (
    <MuiTableBody>
      {data.map((row) => (
        <TableRow<T, CollapsingRowName>
          collapsingRowName={collapsingRowName}
          row={row}
          key={`row-${row.id}`}
          onRowClick={onRowClick}
          getRowBackgroundColor={getRowBackgroundColor}
          getRowOpacity={getRowOpacity}
          selectedProps={selectedProps}
        />
      ))}
    </MuiTableBody>
  );
};

export default TableBody;
